var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _path26, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAccessible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 526,
    height: 350,
    viewBox: "0 0 526 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.418 85.5829L75.8774 138.121L153.239 253.771L231.78 201.232L154.418 85.5829Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.194 195.762L190.305 201.278L151.259 195.65L152.148 190.134L191.194 195.762Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.531 176.085L177.131 176.89L170.922 215.334L165.315 214.522L171.531 176.085Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.6 127.225C135.656 127.302 127.788 132.671 118.023 139.195C108.258 145.719 100.299 150.955 100.243 150.871C100.187 150.787 108.055 145.425 117.82 138.894C127.585 132.363 135.509 127.141 135.6 127.225Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.454 119.973C164.51 120.057 151.42 128.905 135.222 139.741C119.024 150.577 105.822 159.292 105.78 159.215C105.738 159.138 118.8 150.276 135.019 139.44C151.238 128.604 164.398 119.889 164.454 119.973Z",
    fill: "#E0E0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.243 128.625C170.299 128.709 157.209 137.564 141.011 148.4C124.813 159.236 111.611 167.951 111.569 167.867C111.527 167.783 124.603 158.935 140.808 148.092C157.013 137.249 170.187 128.541 170.243 128.625Z",
    fill: "#E0E0E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.032 137.284C176.088 137.368 162.998 146.223 146.8 157.052C130.602 167.881 117.4 176.61 117.4 176.526C117.4 176.442 130.427 167.587 146.632 156.751C162.837 145.915 175.976 137.2 176.032 137.284Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M181.8 145.943C181.856 146.027 168.766 154.875 152.568 165.711C136.37 176.547 123.168 185.262 123.133 185.178C123.098 185.094 136.181 176.246 152.4 165.41C168.619 154.574 181.8 145.859 181.8 145.943Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M417.048 163.075L351.087 207.199L416.057 304.323L482.018 260.199L417.048 163.075Z",
    fill: "#F5F5F5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M447.94 255.626L447.191 260.26L414.396 255.535L415.152 250.901L447.94 255.626Z",
    fill: "#E0E0E0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M431.427 239.099L436.131 239.778L430.916 272.062L426.205 271.383L431.427 239.099Z",
    fill: "#E0E0E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M401.222 198.1C401.278 198.184 394.677 202.699 386.473 208.18C378.269 213.661 371.577 218.043 371.521 217.98C371.465 217.917 378.073 213.388 386.27 207.9C394.467 202.412 401.166 197.981 401.222 198.1Z",
    fill: "#E0E0E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M425.477 191.975C425.533 192.059 414.55 199.507 400.977 208.6C387.404 217.693 376.295 225.015 376.239 224.931C376.183 224.847 387.166 217.399 400.739 208.299C414.312 199.199 425.4 191.891 425.477 191.975Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M430.342 199.241C430.398 199.325 419.415 206.773 405.842 215.873C392.269 224.973 381.16 232.281 381.104 232.197C381.048 232.113 391.996 224.7 405.604 215.6C419.212 206.5 430.3 199.164 430.342 199.241Z",
    fill: "#E0E0E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M435.2 206.5C435.256 206.584 424.266 214.032 410.7 223.132C397.134 232.232 386.018 239.54 385.962 239.456C385.906 239.372 396.889 231.931 410.462 222.824C424.035 213.717 435.151 206.43 435.2 206.5Z",
    fill: "#E0E0E0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M440.1 213.787C440.156 213.871 429.173 221.312 415.6 230.412C402.027 239.512 390.918 246.82 390.862 246.743C390.806 246.666 401.789 239.211 415.362 230.111C428.935 221.011 440.009 213.703 440.1 213.787Z",
    fill: "#E0E0E0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M312.694 89.8376L240.722 51.3434L184.04 157.32L256.012 195.815L312.694 89.8376Z",
    fill: "#F5F5F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M243.694 162.659L239.13 164.22L227.538 132.181L232.109 130.613L243.694 162.659Z",
    fill: "#E0E0E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M250.694 139.671L252.36 144.27L220.538 155.169L218.872 150.57L250.694 139.671Z",
    fill: "#E0E0E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M273.304 92.4C273.248 92.505 265.954 88.711 257.001 83.93C248.048 79.149 240.845 75.18 240.901 75.075C240.957 74.97 248.258 78.764 257.211 83.545C266.164 88.326 273.36 92.288 273.304 92.4Z",
    fill: "#E0E0E0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M290.58 111.461C290.524 111.566 278.442 105.21 263.595 97.272C248.748 89.334 236.764 82.81 236.82 82.705C236.876 82.6 248.951 88.949 263.798 96.894C278.645 104.839 290.636 111.356 290.58 111.461Z",
    fill: "#E0E0E0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M286.338 119.392C286.282 119.497 274.2 113.148 259.353 105.203C244.506 97.258 232.522 90.741 232.578 90.636C232.634 90.531 244.709 96.887 259.556 104.825C274.403 112.763 286.394 119.287 286.338 119.392Z",
    fill: "#E0E0E0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M282.096 127.323C282.04 127.428 269.958 121.079 255.111 113.141C240.264 105.203 228.28 98.7 228.336 98.574C228.392 98.448 240.467 104.818 255.314 112.756C270.161 120.694 282.152 127.218 282.096 127.323Z",
    fill: "#E0E0E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M277.854 135.254C277.798 135.359 265.716 129.01 250.869 121.072C236.022 113.134 224.031 106.61 224.094 106.505C224.157 106.4 236.225 112.749 251.072 120.687C265.919 128.625 277.91 135.149 277.854 135.254Z",
    fill: "#E0E0E0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M278.225 0H276.419V30.786H278.225V0Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M465.069 307.881C465.069 307.979 374.594 308.063 263.007 308.063C151.42 308.063 60.9312 308 60.9312 307.881C60.9312 307.762 151.392 307.699 263.007 307.699C374.622 307.699 465.069 307.776 465.069 307.881Z",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M209.8 164.178L185.02 291.438L181.8 308.098L347 307.3C354.42 307.265 361 300.678 363.373 290.892L392.675 170.751C394.488 163.324 390.512 155.596 384.884 155.603L217.64 155.778C214 155.771 210.738 159.215 209.8 164.178Z",
    fill: "#00C49A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.8 164.178L185.02 291.438L181.8 308.098L347 307.3C354.42 307.265 361 300.678 363.373 290.892L392.675 170.751C394.488 163.324 390.512 155.596 384.884 155.603L217.64 155.778C214 155.771 210.738 159.215 209.8 164.178Z",
    fill: "black"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M331.173 282.8L313.673 141.813C312.973 136.038 308.36 131.726 302.921 131.747L264.561 131.866C263.135 131.882 261.728 132.188 260.425 132.766C259.121 133.344 257.949 134.181 256.98 135.226L238.78 154.595L132.1 155.169C125.583 155.204 120.571 161.378 121.432 168.308L137.679 298.613C138.379 304.381 142.992 308.686 148.417 308.679L334.372 308.308C355.078 308.735 357.059 302.624 357.059 302.624C333.287 307.881 331.173 282.835 331.173 282.8Z",
    fill: "#00C49A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.988 254.604L244.716 261.338L196.416 217.882L202.688 211.148L250.988 254.604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.091 209.657L249.021 215.894L205.32 262.829L198.383 256.592L242.091 209.657Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAccessible);
export default __webpack_public_path__ + "static/media/not-accessible.c2d29db7dca42a19c64a366d701eb67a.svg";
export { ForwardRef as ReactComponent };